"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testHslEquality = void 0;
var tslib_1 = require("tslib");
var numeric_1 = require("../../../../functions/numeric");
var color_test_values_1 = require("../color-test-values");
var testHslEquality = function (name, hsl1, hsl2) {
    test(name, function () {
        var _a = tslib_1.__read(hsl1, 3), h1 = _a[0], s1 = _a[1], l1 = _a[2];
        var _b = tslib_1.__read(hsl2, 3), h2 = _b[0], s2 = _b[1], l2 = _b[2];
        expect((0, numeric_1.dist)(h1, h2) < color_test_values_1.epsilon).toBe(true);
        expect((0, numeric_1.dist)(s1, s2) < color_test_values_1.epsilon).toBe(true);
        expect((0, numeric_1.dist)(l1, l2) < color_test_values_1.epsilon).toBe(true);
    });
};
exports.testHslEquality = testHslEquality;
